import React, { Component } from "react";
import "../css/programs-modern.css";

const recentVideos = [
  { title: "Nama 2020 — Oothukadu Saptha Gurukeerthanais", href: "https://youtu.be/EByS7Cjre5o", detail: "Nama 2020" },
  { title: "Papanasam Sri Sivan Keerthanams", href: "https://www.youtube.com/watch?v=ol8w9XIB5IQ", detail: "Yuva Bhajan Mela Trust, Palakkad" }
];

const pastEventCollections = [
  { title: "Hari Rama Subbu residence", detail: "Frisco, Texas · November 7", href: "https://drive.google.com/folderview?id=0B0S2ZlXDN-CtUDItdlV0cUZ1RkU&usp=sharing" },
  { title: "Radha Kalyanam", detail: "Kansas · August 2014", href: "https://www.youtube.com/playlist?list=PL1sFFfpPjmz_FjfYtu0VdJeEfR4ZQtZpj&feature=em-share_playlist_user" },
  { title: "Sampradaya Bhajans", detail: "Meenakshi Kalyanam", href: "https://www.youtube.com/watch?v=DNFtPxyE-zg&list=PL1sFFfpPjmz8lBjrr-h8wFSd3BIUTCNYT" },
  { title: "Namasankeerthanam", detail: "Bond Street, Irving, Texas · November 2014", href: "https://drive.google.com/folderview?id=0B0S2ZlXDN-CtaGNhZFZ5MkdlSjg&usp=sharing" }
];

const individualRecordings = [
  ["Thodaya Mangalam, Guru Keerthanai, Ashtapadhi — Session 1", "https://www.youtube.com/watch?v=UsHwBSz5fjQ"],
  ["Ashtapadhi — Hey Nandana, Vanamali Vasudeva Jagan Mohana", "https://www.youtube.com/watch?v=K6H471XZ71s"],
  ["Ashtapadhi — Session 3", "https://www.youtube.com/watch?v=l2y80Hp7aoo"],
  ["Ashtapadhi — Krishna Murali Gopala", "https://www.youtube.com/watch?v=sYlVM-xrOnE"],
  ["Ashtapadhi — Oh Rama Nee Namam, Jaya Janaki, Atma Rama", "https://www.youtube.com/watch?v=WQc43E9I0fA"],
  ["Ashtapadhi — Chethashri Ramam, Sakala Loka Nayike", "https://www.youtube.com/watch?v=c9wUdeET32U"],
  ["Divyanamam — Session 1", "http://youtu.be/De6GQumTjXQ"],
  ["Divyanamam — Session 2", "http://youtu.be/77kl1o29Y8Q"],
  ["Murahara, Yelello, Namacha Bazaar", "https://www.youtube.com/watch?v=ds5HPAB3a6w"],
  ["Saasasathvaja Sanandam, Radhey Govinda", "https://www.youtube.com/watch?v=5xHYyRyGenA"],
  ["Allo Nere, Suvvi, Chitha Juni Jayamangalam", "http://youtu.be/Incrsyz23So"]
];

const meenakshiKalyanam = [
  ["Slokam — Thodaya Mangalam (Sivan)", "https://www.youtube.com/watch?v=DNFtPxyE-zg"],
  ["Guru Keerthanai", "https://www.youtube.com/watch?v=KLDSKxo1MOo"],
  ["Sivashtapadhi — Kalyanam 03", "https://www.youtube.com/watch?v=alcJHO6MJCU"],
  ["Sivashtapadhi — Kalyanam 04", "https://www.youtube.com/watch?v=sFj9HKo9pyE"],
  ["Sivashtapadhi — Kalyanam 05", "https://www.youtube.com/watch?v=-ba6Tt7F9v0"],
  ["Sivashtapadhi — Kalyanam 06", "https://www.youtube.com/watch?v=nN8OhWQD8O4"],
  ["Sivashtapadhi — Kalyanam 07", "https://www.youtube.com/watch?v=_v3EAWj6SFY"],
  ["Sivashtapadhi — Kalyanam 08", "https://www.youtube.com/watch?v=_ogLEHp0q-g"]
];

const ExternalLink = ({ href, children, className = "" }) => <a className={className} href={href} target="_blank" rel="noopener noreferrer">{children}<span aria-hidden="true"> ↗</span></a>;

class ProgramAndEvents extends Component {
  constructor(props) {
    super(props);
    window.clickLog("load", "ProgramAndEvents");
  }

  componentDidMount() {
    window.getList();
  }

  render() {
    return (
      <article className="programs-page">
        <header className="programs-intro">
          <p className="eyebrow">Gatherings and recordings</p>
          <h1>Programs &amp; Events</h1>
          <p>Browse current programs, recent recordings and a growing archive of devotional gatherings.</p>
        </header>

        <section className="programs-panel programs-panel--schedule" aria-labelledby="schedule-title">
          <div className="programs-panel__heading"><p className="programs-kicker">Current programs</p><h2 id="schedule-title">Upcoming gatherings</h2><p>The current program list is shown below as soon as it is available.</p></div>
          <div id="htmlcontent" className="program-table" aria-live="polite" />
        </section>

        <section className="programs-section" aria-labelledby="recent-videos-title">
          <div className="programs-section__heading"><p className="programs-kicker">Watch and listen</p><h2 id="recent-videos-title">Recent YouTube videos</h2></div>
          <div className="recent-video-grid">
            {recentVideos.map(video => <ExternalLink key={video.href} href={video.href} className="recent-video"><span className="recent-video__play" aria-hidden="true">▶</span><span><strong>{video.title}</strong><small>{video.detail}</small></span></ExternalLink>)}
          </div>
        </section>

        <section className="programs-section" aria-labelledby="past-events-title">
          <div className="programs-section__heading"><p className="programs-kicker">Always open</p><h2 id="past-events-title">Past events</h2><p>Explore event collections and individual recordings from the samajam archive.</p></div>
          <div className="event-collection-grid">
            {pastEventCollections.map(event => <ExternalLink key={event.href} href={event.href} className="event-collection"><span className="event-collection__label">Archive</span><strong>{event.title}</strong><small>{event.detail}</small></ExternalLink>)}
          </div>
        </section>

        <section className="archive-section" aria-labelledby="recordings-title">
          <div className="archive-section__heading"><p className="programs-kicker">Kansas archive</p><h2 id="recordings-title">Individual recordings</h2></div>
          <div className="recording-list">{individualRecordings.map(([title, href], index) => <ExternalLink key={href} href={href} className="recording-list__item"><span>{String(index + 1).padStart(2, "0")}</span>{title}</ExternalLink>)}</div>
        </section>

        <section className="archive-section archive-section--gold" aria-labelledby="meenakshi-title">
          <div className="archive-section__heading"><p className="programs-kicker">February 2014</p><h2 id="meenakshi-title">Meenakshi Kalyanam</h2></div>
          <div className="recording-list">{meenakshiKalyanam.map(([title, href], index) => <ExternalLink key={href} href={href} className="recording-list__item"><span>{String(index + 1).padStart(2, "0")}</span>{title}</ExternalLink>)}</div>
        </section>

        <aside className="charity-note"><p className="programs-kicker">Charitable activities</p><h2>Service as an offering</h2><p>Our trust is a non-profit charitable organisation. Through available resources, it supports educational and medical assistance, artificial limbs, marriage assistance, poor feeding during Karthikai Pournami, medical camps, eye camps and assistance for people affected by leprosy.</p><p>One medical camp at Baba Gurukulam, Pozhichalur served 120 children and 25 elders with general check-ups and medicines.</p></aside>
      </article>
    );
  }
}

export default ProgramAndEvents;
